'use strict';

// Centralized styled-components import to guarantee a single runtime instance.
const styledComponents = require('styled-components');

module.exports = styledComponents;
